module.exports = __webpack_public_path__ + "img/flag.862be370.svg";